var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#222222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_8252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.8C15.112 16.8 14.4 17.512 14.4 18.4C14.4 18.8243 14.5685 19.2313 14.8686 19.5314C15.1686 19.8314 15.5756 20 16 20C16.4243 20 16.8313 19.8314 17.1313 19.5314C17.4314 19.2313 17.6 18.8243 17.6 18.4C17.6 17.512 16.88 16.8 16 16.8ZM3.19995 4V5.6H4.79995L7.67995 11.672L6.59195 13.632C6.47195 13.856 6.39995 14.12 6.39995 14.4C6.39995 14.8243 6.56852 15.2313 6.86858 15.5314C7.16864 15.8314 7.5756 16 7.99995 16H17.6V14.4H8.33595C8.28291 14.4 8.23204 14.3789 8.19453 14.3414C8.15702 14.3039 8.13595 14.253 8.13595 14.2C8.13595 14.16 8.14395 14.128 8.15995 14.104L8.87995 12.8H14.84C15.44 12.8 15.968 12.464 16.24 11.976L19.104 6.8C19.16 6.672 19.2 6.536 19.2 6.4C19.2 6.18783 19.1157 5.98434 18.9656 5.83431C18.8156 5.68429 18.6121 5.6 18.4 5.6H6.56795L5.81595 4H3.19995ZM7.99995 16.8C7.11195 16.8 6.39995 17.512 6.39995 18.4C6.39995 18.8243 6.56852 19.2313 6.86858 19.5314C7.16864 19.8314 7.5756 20 7.99995 20C8.4243 20 8.83126 19.8314 9.13132 19.5314C9.43138 19.2313 9.59995 18.8243 9.59995 18.4C9.59995 17.512 8.87995 16.8 7.99995 16.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_8252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.3999 2.3999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconFilled);
export default __webpack_public_path__ + "static/media/cart-icon-filled.de9bc69dc5893601b451faed8ba151cb.svg";
export { ForwardRef as ReactComponent };